module.exports = __webpack_public_path__ + "static/media/5.c23adf26.jpg";